var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsStrongPassword } from "class-validator";
import { EmailAddressResolver, GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { CommitteeIdentifier, CommitteeRole, DbRole, } from "../../authorization/structures.js";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { PersonNode } from "../resources/Person.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListPeopleResponse = class ListPeopleResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [PersonNode], { nullable: false }),
    __metadata("design:type", Array)
], ListPeopleResponse.prototype, "data", void 0);
ListPeopleResponse = __decorate([
    ObjectType("ListPeopleResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListPeopleResponse);
export { ListPeopleResponse };
let MemberOf = class MemberOf {
    id;
    committeeRole;
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], MemberOf.prototype, "id", void 0);
__decorate([
    Field(() => CommitteeRole, { nullable: true }),
    __metadata("design:type", Object)
], MemberOf.prototype, "committeeRole", void 0);
MemberOf = __decorate([
    InputType()
], MemberOf);
let ListPeopleArgs = class ListPeopleArgs extends FilteredListQueryArgs("PersonResolver", [
    "name",
    "email",
    "linkblue",
    "committeeRole",
    "committeeName",
]) {
};
ListPeopleArgs = __decorate([
    ArgsType()
], ListPeopleArgs);
export { ListPeopleArgs };
let CreatePersonInput = class CreatePersonInput {
    name;
    email;
    linkblue;
    dbRole;
    memberOf = [];
    captainOf = [];
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], CreatePersonInput.prototype, "name", void 0);
__decorate([
    Field(() => EmailAddressResolver, { nullable: false }),
    __metadata("design:type", String)
], CreatePersonInput.prototype, "email", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], CreatePersonInput.prototype, "linkblue", void 0);
__decorate([
    Field(() => DbRole, {
        nullable: true,
        deprecationReason: "DBRole can no longer be set directly",
    }),
    __metadata("design:type", String)
], CreatePersonInput.prototype, "dbRole", void 0);
__decorate([
    Field(() => [MemberOf], { nullable: true }),
    __metadata("design:type", Array)
], CreatePersonInput.prototype, "memberOf", void 0);
__decorate([
    Field(() => [MemberOf], { nullable: true }),
    __metadata("design:type", Array)
], CreatePersonInput.prototype, "captainOf", void 0);
CreatePersonInput = __decorate([
    InputType()
], CreatePersonInput);
export { CreatePersonInput };
let SetPersonInput = class SetPersonInput {
    name;
    email;
    linkblue;
    memberOf;
    captainOf;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], SetPersonInput.prototype, "name", void 0);
__decorate([
    Field(() => EmailAddressResolver, { nullable: true }),
    __metadata("design:type", String)
], SetPersonInput.prototype, "email", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", String)
], SetPersonInput.prototype, "linkblue", void 0);
__decorate([
    Field(() => [MemberOf], { nullable: true }),
    __metadata("design:type", Array)
], SetPersonInput.prototype, "memberOf", void 0);
__decorate([
    Field(() => [MemberOf], { nullable: true }),
    __metadata("design:type", Array)
], SetPersonInput.prototype, "captainOf", void 0);
SetPersonInput = __decorate([
    InputType()
], SetPersonInput);
export { SetPersonInput };
let BulkPersonInput = class BulkPersonInput {
    name;
    email;
    linkblue;
    committee;
    role;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], BulkPersonInput.prototype, "name", void 0);
__decorate([
    Field(() => EmailAddressResolver, { nullable: false }),
    __metadata("design:type", String)
], BulkPersonInput.prototype, "email", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], BulkPersonInput.prototype, "linkblue", void 0);
__decorate([
    Field(() => CommitteeIdentifier, { nullable: true }),
    __metadata("design:type", Object)
], BulkPersonInput.prototype, "committee", void 0);
__decorate([
    Field(() => CommitteeRole, { nullable: true }),
    __metadata("design:type", Object)
], BulkPersonInput.prototype, "role", void 0);
BulkPersonInput = __decorate([
    InputType()
], BulkPersonInput);
export { BulkPersonInput };
let SetPasswordInput = class SetPasswordInput {
    password;
};
__decorate([
    IsStrongPassword({}),
    Field(() => GraphQLNonEmptyString, {
        nullable: true,
        description: "If set to a string, replaces or sets the user's password. If set to null it clears any existing password",
    }),
    __metadata("design:type", Object)
], SetPasswordInput.prototype, "password", void 0);
SetPasswordInput = __decorate([
    InputType()
], SetPasswordInput);
export { SetPasswordInput };
//# sourceMappingURL=personParams.js.map